export default "__VITE_ASSET__DdET$wWj__"